import { use2FAState, useOnSuccessPlus } from "Login/TwoFA/API/queryHooks";
import { useTwoFAContext } from "Login/TwoFA/TwoFA";

import FnrRedirect from "UI/FnrRedirect";

import PromptTypography from "../../PromptTypography";

const Redirecting = () => {
  const [apiState] = use2FAState();
  const { redirectUrl } = apiState;
  const { noRedirect } = useTwoFAContext();
  const onSuccess = useOnSuccessPlus();

  return (
    <FnrRedirect
      callback={onSuccess}
      data-cy="TwoFA_Redirect"
      url={noRedirect ? "" : redirectUrl}
      target="_self"
      fullWidth
    >
      <PromptTypography>Authentication was successful</PromptTypography>
    </FnrRedirect>
  );
};

export default Redirecting;
